import React from "react";
import ReactDOM from "react-dom";
import { initSentrySession } from "../../service/SentryService";
import { StyleProvider } from '../../customHooks/useStyleContext';
import { CustomerProvider } from '../../customHooks/useCustomer';
import MenuContainer from '../components/MenuContainer/MenuContainer';

const rootElement = document.getElementById("customer-menu");

initSentrySession(typeof app_env !== 'undefined' ? app_env : 'dev');

const appHeight = () => {
    const doc = document.documentElement
    doc.style.setProperty('--app-height', `${window.innerHeight}px`)
}

const renderApp = () => {
    if (!rootElement) {
        return;
    }

    ReactDOM.render(
        <StyleProvider>
            <CustomerProvider>
                <MenuContainer />
            </CustomerProvider>
        </StyleProvider>,
        rootElement
    );
};

renderApp();
appHeight();
